import React from 'react';
import { Button } from 'reactstrap';
export default function CustomDeleteButton(props){  
    const {keyvalue} = props;  
    return(
        <Button
            type="button"
            className='action-btn'
            color='danger'
            id={`tooltip_delete_key_${keyvalue}`}
            title="Remove"
            aria-label="Remove"
            {...props}
        >
            <span className='far fa-trash-alt'></span>
        </Button>
    );
}
